<div class="main-content">
  <h2 mat-dialog-title>Confirm Delete</h2>
  <img
    src="../../../../assets/Icons/transfer-error-icon-200x200.png"
    alt="Orange Exclamation Mark Image"
    width="80"
    height="80"
    class="error-image"
  />
  <mat-dialog-content>
    Are you sure you want to delete?
    @if (errorMessage) {
      <p class="delete-error">{{ errorMessage }}</p>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button (click)="onConfirm()">Delete</button>
  </mat-dialog-actions>
</div>
